/*---- Sagas -----*/
export const INITIALISING = 'INITIALISING';

/*---- InitReducer ----*/
export const UPDATE_PARTICIPANTS = 'UPDATE_PARTICIPANTS';
export const SEARCH_PARTICIPANT = 'SEARCH_PARTICIPANT'
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const GLOBAL_LOAD = 'GLOBAL_LOAD';
export const INFO_SUCCESS = 'INFO_SUCCESS';
export const GET_INFO = 'GET_INFO';
export const CHECK_OUT = 'CHECK_OUT';
export const CHECKING_OUT = 'CHECKING_OUT';
export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS';